import React, {useState} from 'react';
import cn from 'classnames';

import MySaleCard from '../sales/card';
import useGetMyAdverisements from '../../../../services/hookService/getMyAdvertisements/useGetAdverisements';
import DotsLoading from '../../../../components/dotsLoading';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {DeleteBotoomSheet} from '../sales';
import useDeleteMyAdvertisment from '../../../../services/hookService/my-account/deleteMyAdvertisment/useDeleteMyAdvertisment';
import NotFoundIcon from './../../../../assets/image/sponsor/404.svg';
import {useNavigate} from 'react-router-dom';
import useGetAllNotifications from '../../../../services/hookService/getAllNotification/useGetAllNotifications';

type ServiceType = 'give_service' | 'get_service';

const serviceAdTypeMap: Record<ServiceType, 'advertisement' | 'requirement'> = {
  give_service: 'advertisement',
  get_service: 'requirement',
};

const Services = () => {
  const navigate = useNavigate();
  const [serviceType, setServiceType] = useState<ServiceType>('give_service');
  const {data, isLoading, refetch} = useGetMyAdverisements({
    filter: serviceType,
  });
  const [deleteItem, setDeleteItem] = useState<DeleteBotoomSheet>({
    isOpen: false,
    data: null,
  });
  const {refetch: refetchAdNotificatons} = useGetAllNotifications();
  const {mutate} = useDeleteMyAdvertisment({
    filter: 'advertisement',
    refetch: () => {
      refetch();
      refetchAdNotificatons();
      setDeleteItem({isOpen: false, data: null});
    },
  });
  const handeDeleteItem = (guid: string) => {
    mutate(guid);
  };
  return (
    <>
      <div className="flex justify-between gap-2 my-4">
        <button
          className={cn('py-2 w-1/2 rounded-lg bg-gray-50 border-[1px]', {
            ' text-farm-shop-500 !border-farm-shop-500':
              serviceType === 'give_service',
            ' text-gray-600 border-transparent': serviceType !== 'give_service',
          })}
          onClick={() => setServiceType('give_service')}
        >
          ارائه خدمات
        </button>
        <button
          className={cn('py-2 w-1/2 rounded-lg bg-gray-50 border-[1px]', {
            'text-farm-shop-500 !border-farm-shop-500':
              serviceType === 'get_service',
            'text-gray-600 border-transparent': serviceType !== 'get_service',
          })}
          onClick={() => setServiceType('get_service')}
        >
          دریافت خدمات
        </button>
      </div>
      {isLoading ? (
        <div className="my-auto">
          <DotsLoading />
        </div>
      ) : (
        <>
          {!data?.length ? (
            <div className="flex flex-col items-center justify-center px-3 text-sm text-gray-800 flex-1">
              <div className="flex flex-col justify-center items-center gap-6">
                <img src={NotFoundIcon} alt="not found" className="w-14" />
                <span>شما در این دسته آگهی‌ ثبت نکرده‌اید</span>
              </div>
              <button
                className="w-full text-farm-shop-500 border-[1px] border-solid !border-farm-shop-500 rounded bg-white py-3 mt-28"
                onClick={() => navigate('/advertisement-registeration')}
              >
                ثبت آگهی خدمات
              </button>
            </div>
          ) : (
            data?.map((item, index) => (
              <MySaleCard
                setDeleteItem={setDeleteItem}
                data={item}
                key={item.guid}
                type={serviceAdTypeMap[serviceType]}
              />
            ))
          )}
        </>
      )}
      <BottomSheet
        onDismiss={() => {
          setDeleteItem({isOpen: false, data: null});
        }}
        open={deleteItem.isOpen}
        blocking={true}
        className="transition ease-in-out delay-250 "
      >
        <div className="w-full flex flex-col gap-3 p-3">
          <div className="flex w-full justify-between">
            <p>حذف آگهی</p>
            <SpanIcon
              className="icon-nameClose-remove text-xl"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            />
          </div>
          <p>آیا اطمینان به حذف آگهی {deleteItem.data?.title} دارید؟</p>
          <div className="w-full flex justify-between gap-2 items-center text-md font-Medium">
            <button
              className="w-[70%] bg-red-500 h-[48px] text-white rounded-[8px]"
              onClick={() => handeDeleteItem(deleteItem.data?.guid || '')}
            >
              بله، حذف{' '}
            </button>
            <button
              className="w-[30%] text-farm-shop-500 h-[48px] border border-farm-shop-500 rounded-[8px]"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            >
              خیر
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default Services;
